import React, { useState, useEffect } from 'react';
import { liveDataAPI } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

export default function AdminElections() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await liveDataAPI.elections();
        setData(res.data);
      } catch (e) { console.error(e); }
      setLoading(false);
    })();
  }, []);

  const handleRefresh = async () => {
    setLoading(true);
    try {
      const res = await liveDataAPI.elections();
      setData(res.data);
      toast({ title: 'Election data refreshed' });
    } catch (e) { toast({ title: 'Error', description: e.message, variant: 'destructive' }); }
    setLoading(false);
  };

  if (loading) return <div style={{ padding: 32, color: '#999' }}>Loading election data…</div>;

  const races = data?.races || data?.elections || [];
  const lastUpdated = data?.last_updated || data?.updated_at;

  return (
    <div style={{ padding: '24px 32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#e8e8e8', margin: '0 0 4px' }}>Election Tracker</h1>
          <p style={{ color: '#888', fontSize: 14 }}>
            Live election results and race tracking
            {lastUpdated && <span> · Updated: {new Date(lastUpdated).toLocaleString()}</span>}
          </p>
        </div>
        <button onClick={handleRefresh} style={{ background: '#b89b5e', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
          ⟳ Refresh
        </button>
      </div>

      {races.length === 0 && (
        <div style={{ background: '#1a1b1e', borderRadius: 12, padding: 40, textAlign: 'center', border: '1px solid #2a2b2e' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🗳️</div>
          <div style={{ color: '#888', fontSize: 15 }}>No active elections being tracked</div>
          <div style={{ color: '#555', fontSize: 13, marginTop: 8 }}>Configure the GOOGLE_CIVIC_API_KEY in your environment to enable live election data</div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {races.map((race, i) => (
          <div key={race.id || i} style={{ background: '#1a1b1e', borderRadius: 12, padding: 20, border: '1px solid #2a2b2e' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ color: '#e8e8e8', fontWeight: 700, fontSize: 16 }}>{race.name || race.office || 'Race'}</div>
              <span style={{ fontSize: 11, fontWeight: 600, color: race.called ? '#1f7a5a' : '#b89b5e', padding: '4px 10px', borderRadius: 12, background: race.called ? 'rgba(31,122,90,0.15)' : 'rgba(184,155,94,0.15)' }}>
                {race.called ? '✓ Called' : '● Live'}
              </span>
            </div>
            {(race.candidates || []).map((c, j) => {
              const pct = c.percentage || c.vote_pct || 0;
              return (
                <div key={j} style={{ marginBottom: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <span style={{ color: '#ccc', fontSize: 14 }}>{c.name} <span style={{ color: '#666', fontSize: 12 }}>({c.party || '—'})</span></span>
                    <span style={{ color: '#e8e8e8', fontWeight: 600, fontSize: 14 }}>{pct.toFixed(1)}%</span>
                  </div>
                  <div style={{ height: 6, borderRadius: 3, background: '#2a2b2e', overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 3, width: `${Math.min(pct, 100)}%`, background: c.party === 'D' || c.party === 'Democrat' ? '#3b82f6' : c.party === 'R' || c.party === 'Republican' ? '#ef4444' : '#b89b5e', transition: 'width 0.3s ease' }} />
                  </div>
                </div>
              );
            })}
            {race.reporting_pct != null && (
              <div style={{ color: '#555', fontSize: 11, marginTop: 8 }}>{race.reporting_pct}% reporting</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
